module.exports = __webpack_public_path__ + "static/img/ent-detail-51.c01e4b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-51.jpg
// module id = u+wa
// module chunks = 52